import PropTypes from "prop-types"

import { cn } from "styles/utils"

export const PageTitle = ({
  as,
  className = "",
  subtitle,
  isNewDesign,
  ...props
}) => {
  const Comp = as ?? "h1"
  return (
    <Comp
      className={cn(
        "text-neutral mb-32 text-center font-light",
        subtitle ? "text-18 tablet:mt-16 mt-8" : "text-30 tablet:text-26",
        isNewDesign
          ? "text-32 leading-36 font-bold text-black"
          : "bg-linear-to-t from-transparent to-[#ababab] bg-[size:13%_1px] bg-bottom bg-no-repeat pb-16",
        className
      )}
      {...props}
    />
  )
}
PageTitle.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  isNewDesign: PropTypes.bool,
  subtitle: PropTypes.bool,
}

export default PageTitle
